export class Login {
  static readonly type = '[Auth] Login';
}

export class FetchToken {
  static readonly type = '[Auth] Fetch token';

  constructor(readonly code: string) {}
}

export class RefreshToken {
  static readonly type = '[Auth] Refresh token';
}

export class Logout {
  static readonly type = '[Auth] Logout';
}

export class ClearTokens {
  static readonly type = '[Auth] Clear tokens';
}

export class InitAuth {
  static readonly type = '[Auth] Init';

  constructor(readonly wicketEnabled: boolean) {}
}
export class SetToken {
  static readonly type = '[Auth] Set token';

  constructor(
    readonly token: string | null,
    readonly refreshToken: string | null,
    readonly afterRefresh?: boolean,
  ) {}
}
